// Calendly integration utility with optimized loading
let calendlyLoaded = false
let calendlyLoadPromise: Promise<void> | null = null

export const loadCalendlyScript = (): Promise<void> => {
  if (calendlyLoaded) {
    return Promise.resolve()
  }
  if (calendlyLoadPromise) {
    return calendlyLoadPromise
  }
  calendlyLoadPromise = new Promise((resolve, reject) => {
    if (document.querySelector('script[src*="calendly"]')) {
      calendlyLoaded = true
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = 'https://assets.calendly.com/assets/external/widget.js'
    script.async = true
    script.onload = () => {
      calendlyLoaded = true
      resolve()
    }
    script.onerror = () => {
      calendlyLoadPromise = null
      reject(new Error('Calendly konnte nicht geladen werden'))
    }
    document.head.appendChild(script)

    const link = document.createElement('link')
    link.href = 'https://assets.calendly.com/assets/external/widget.css'
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  })
  return calendlyLoadPromise
}

export function openCalendlyPopup() {
  const target = document.getElementById('termin')
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' })
  } else {
    window.location.href = '/#termin'
  }
}
